import styled from "styled-components";
import { device } from "../../../../style/styled-components/helpers/device";
// 통관 구분 기준 금액 원형. sub(예: "(미국 $200)")는 금액 아래 작은 글씨로 넣어 원 안에 들어가게 한다
const ExpressUnderstandingDiv = ({ amount, sub }) => {
  return (
    <Div>
      <b>{amount}</b>
      {sub && <span>{sub}</span>}
    </Div>
  );
};
export default ExpressUnderstandingDiv;
const Div = styled.div`
  box-sizing: border-box;
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.line};
  background-color: white;
  box-shadow: ${({ theme }) => theme.shadow.sm};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  line-height: 1.2;
  white-space: nowrap;
  & > b {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.dark};
  }
  & > span {
    font-size: 0.65rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.foreground.dimmed};
  }
  @media ${device.tablet} {
    width: 6rem;
    height: 6rem;
    & > b {
      font-size: 1.15rem;
    }
    & > span {
      font-size: 0.75rem;
    }
  }
  @media ${device.laptop} {
    width: 7rem;
    height: 7rem;
    & > b {
      font-size: 1.35rem;
    }
    & > span {
      font-size: 0.85rem;
    }
  }
`;
